import CryptoJS from "crypto-js"
import { getSecret } from "../store/token";
export class CryptEngine {
    /**
     * 加密
     */
    public static encode(encrypt: number, decodeStr: string, cId: any) {
        const secret = getSecret();
        if (encrypt !== 1 || (secret && secret.length === 0)) {
            return decodeStr
        }
        return this.handleEncode(decodeStr, secret, cId)
    }

    public static handleEncode(decodeStr: string, secret: string, cId: any) {
        if (secret.length === 0) {
            return decodeStr
        }
        let key = this.md5(`${secret}-${cId}`).toUpperCase().trim()
        key = this.base64Encode(key).trim()
        //对内容 base64
        const decode = this.base64Encode(decodeStr).trim()
        const n = decode.length;
        let str = ''
        for (let i = 0; i < n; i++) {
            const code1 = decode.charAt(i).charCodeAt(0)
            const code2 = key[i % key.length].charCodeAt(0);
            const xorResult = String.fromCharCode(code1 ^ code2);
            str = str + xorResult
        }
        str = this.base64Encode(str)
        //console.log("===加密", secret, cId, decodeStr, str)
        return str
    }
    public static md5(str: string) {
        return CryptoJS.MD5(str).toString();
        // const md5 = stringMd5(str);
    }

    public static base64Encode(str: string) {
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str));
        // const base64 = btoa(str);
        // return base64
    }

    public static base64Decode(str: string) {
        try {
            const words = CryptoJS.enc.Base64.parse(str);
            return words.toString(CryptoJS.enc.Utf8);
        } catch {
            return str
        }

    }

    /**
     * 解密
     */
    public static decode(encrypt: number, encodeStr: string, cId: any): string {
        const secret = getSecret();
        if (encrypt !== 1 || (secret && secret.length == 0)) {
            return encodeStr
        }
        let key = this.md5(`${secret}-${cId}`).toUpperCase().trim()
        key = this.base64Encode(key).trim()
        const decode = this.base64Decode(encodeStr)
        const n = decode.length;
        let str = ''
        for (let i = 0; i < n; i++) {
            const code1 = decode.charAt(i).charCodeAt(0);
            const code2 = key[i % key.length].charCodeAt(0);
            const xorResult = code1 ^ code2;
            str = str + String.fromCharCode(xorResult)
        }
        str = this.base64Decode(str)
        return str
    }
}